export interface IIncentiveType {
    incentiveTypeId: number;
    name: string;
    code: string;
}

export class IncentiveType implements IIncentiveType {
    incentiveTypeId: number;
    name: string;
    code: string;

    constructor(name: string, code: string) {
        this.name = name;
        this.code = code;
    }
}